export interface Product {
  RSPF_PROD_N: string;
  RSPF_DESC: string;
  IS_METERED: string;
  LAST_METER: number;
  RSCH_CONTRACT_N: string | null;
  RSCH_CUST_N: string | null;
}
